var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-row',{staticClass:"bbottom"},[_c('van-col',{attrs:{"span":"24"}},[_vm._v(" "+_vm._s(_vm.$store.state.siteinfo.sitename)+" "),_c('p',{staticClass:"gspt"},[_vm._v(_vm._s(_vm.$store.state.siteinfo.subname))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }